// services/Translation/lang.js
import { langArr } from './language';
import { acceptedLang } from '../Helpers/AcceptedLangs';

const normalizeLang = (l) => {
  let lang = (l || 'en').toLowerCase();
  if (lang === 'rs') lang = 'sr';
  if (!acceptedLang(lang)) lang = 'en';
  return lang;
};

const urlParams = new URLSearchParams(window.location.search);
let language = normalizeLang(urlParams.get('language') || urlParams.get('lang'));

export const translate = (word) => {
  if (!word) return '';
  const key = String(word).toLowerCase();
  const dict = langArr[language] || {};
  if (key in dict) return dict[key];
  console.error('word not translated:', key);
  return key;
};

export const languageReinit = (lang) => {
  language = normalizeLang(lang);
  // obavesti React svet da je jezik promenjen
  window.dispatchEvent(new CustomEvent('lang:changed', { detail: { language } }));
};

export const getCurrentLanguage = () => language;

export default translate;
